import { PromocodesList } from './PromocodesList';

export default {
  list: PromocodesList,
};
